module.exports = __webpack_public_path__ + "static/PHOTO DR DHAARNA-f6f69205d4465cbcdee51df5b8f45016.png";